<template>
    <transition name="uik-popup">
        <div
            v-if="visible || delayed"
            ref="wrapper"
            class="uik-popup"
            tabindex="0"
            @keydown.esc="handleKey('close')"
            @keydown.enter="handleKey('confirm')"
        >
            <div
                class="uik-popup__content"
                :style="'max-width: ' + maxWidth + 'px;'">
                <div class="uik-popup__close" @click="close">
                    <Uikon>add</Uikon>
                </div>
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "UikPopup",
    props: {
        open_popup: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Number,
            default: 490
        },
        visible: {
            type: Boolean,
            default: null
        }
    },
    data () {
        return {
            delayed: false
        }
    },
    created () {
        this.$emit("created")

        if (this.visible === null) {
            this.delayed = false
            setTimeout(() => { this.delayed = true }, 50)
        }
    },
    mounted () {
        this.$emit("mounted")

        if (this.$refs.wrapper) this.$refs.wrapper.focus()
    },
    beforeDestroy () {
        this.$emit("beforeDestroy")
    },
    methods: {
        close () {
            this.$emit("close", false)
        },
        handleKey (event) {
            let focusedEl = document.activeElement.tagName.toLowerCase()
            if (focusedEl === "textarea" && event === "confirm") return
            this.$emit(event)
        }
    }
}
</script>

<style lang="scss">
.uik-popup {
    background-color: transparent;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 2000;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    .uik-popup__content {
        border-radius: 4px;
        background: white;
        width: 90%;
        height: auto;
        max-height: 100%;
        position: relative;
        pointer-events: all;
        animation: uik-popup-appear 0.25s;
        @keyframes uik-popup-appear {
            from {
                opacity: 0;
                transform: scale(0.85);
            }
            to {
                opacity: 1;
                transform: none;
            }
        }
        .uik-popup__close {
            transform: rotate(45deg) !important;
            position: absolute;
            top: 33px;
            right: 30px;
            color: $textSecondary;
            cursor: pointer;
            transition: all 0.15s;
            i {
                font-size: 14px;
            }
            &:hover {
                color: $textBase;
                transform: scale(1.3) rotate(45deg) !important;
            }
        }
        .uik-popup__section {
            margin: 0;
            padding: 25px;
            border-bottom: 1px solid $borderColor;
        }
        .uik-popup__section:last-child {
            border: none;
        }
        h2 {
            padding: 8px 45px 22px 25px;
            border-bottom: 1px solid $borderColor;
        }
        .uik-popup__label {
          display: inline-block;
          margin-top: 15px;
        }
        .uik-popup__scroll-wrapper {
          overflow: auto;
          max-height: calc(100vh - 250px);
          &::-webkit-scrollbar-track {
              display: initial;
          }
          &::-webkit-scrollbar {
              display: initial;
          }
        }
    }
    @media only screen and (max-width: 650px) {
        min-width: unset;
        width: 100%;
    }
}
</style>
